import type { Variants } from 'framer-motion';

export const STAMP_ENTER_SECONDS = 0.2;
export const STAMP_STAGGER_STEP_SECONDS = STAMP_ENTER_SECONDS * 0.55;
export const STAMP_STAGGER_BASE_DELAY_SECONDS = 0.3;
export const STAMP_JUST_EARNED_EXTRA_DELAY_SECONDS = 0.3;

export const stampVariants: Variants = {
  hidden: { scale: 0.6, opacity: 0 },
  visible: (staggerIndex: number) => ({
    scale: 1,
    opacity: 1,
    transition: {
      duration: STAMP_ENTER_SECONDS,
      ease: [0.34, 1.15, 0.64, 1],
      delay: STAMP_STAGGER_BASE_DELAY_SECONDS + staggerIndex * STAMP_STAGGER_STEP_SECONDS,
    },
  }),
};
